<template>
	<div>
		<h3>业绩指标设置</h3>
		<div>
			<el-date-picker v-model="filter.month" type="month" size="small" :clearable="clear" value-format="yyyy-MM"
				style="width:120px; margin: 0px 20px;">
			</el-date-picker>
			<el-input class="input_style" size="small" v-model="filter.name" placeholder="店铺名称"></el-input>
			<el-button type="primary" size="small" @click="getTurnover">筛选</el-button>
			<el-button type="primary" size="small" @click="plsc()" style="float: right;">导入</el-button>
			<input type="file" name="file" style="opacity: 0;position: absolute;display: none;" id="sj"
				@change="xuanzhe($event)" />
		</div>
		<div>
			<el-table :data="tableData">
				<el-table-column prop="title" label="门店" width="150" align="center"></el-table-column>
				<el-table-column prop="state" label="门店状态" width="120" align="center">
					<template slot-scope="scope">
						{{ scope.row.state|stateFormat }}
					</template>
				</el-table-column>
				<el-table-column prop="workerTurnovers" label="店员数量" width="120" align="center">
					<template slot-scope="scope">
						{{ scope.row.workerTurnovers.length }}
					</template>
				</el-table-column>
				<el-table-column prop="turnover" label="门店指标" align="center" width="150">
					<template slot-scope="scope">
						{{ scope.row.turnover ?scope.row.turnover :'暂未设置指标' }}
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="settings(scope.row)">指标设置</el-button>
						<!-- <el-button type="primary" size="mini">导出</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<!-- 			<el-pagination
				background
				@current-change="dataByPage"
				layout="prev, pager, next"
				:total="filter.total">
			</el-pagination> -->
		</div>
		<el-dialog title="设置指标" :visible.sync="settingWindow" width="60%">
			<div style="height: 500px;">
				<div><b style="font-size:18px">所设月份：{{ filter.month }}</b></div>
				<el-col :span="8">
					<div>
						<h4>门店营业额</h4>
						<div>
							<span style="width: 100px; display: inline-block;">{{ selectStore.title }}</span>
							<!-- <el-input-number v-model="selectStore.turnover" :min='0' class="input_style" size="small" :disabled="status" :controls='false'></el-input-number> -->
							<el-input-number v-model="selectStore.turnover" :min='0' class="input_style" size="small"
								:controls='false'></el-input-number>
						</div>
					</div>
				</el-col>
				<el-col :span="16">
					<div style="border-left: 1px solid #000; padding-left: 20px;">
						<h4>发型师营业额</h4>
						<div v-for="item in selectStore.workerTurnovers" :key="item.id">
							<span style="width: 100px; display: inline-block;">{{ item.name }}</span>
							<span style="width: 100px; display: inline-block;">{{ item.type|typeFormat }}</span>
							<!-- <el-input-number :min='0' class="input_style" size="small" :disabled="status" :controls='false' v-model="item.turnover"></el-input-number> -->
							<el-input-number :min='0' class="input_style" size="small" :controls='false'
								v-model="item.turnover"></el-input-number>
						</div>
					</div>
				</el-col>
			</div>
			<div style="margin-left: 80%">
				<el-button @click="settingWindow=false">取消</el-button>
				<el-button type="primary" @click="edit">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import {
		url
	} from '../../../utils/index.js'
	import journalVue from '../../system/journal.vue';
	export default {
		data() {
			return {
				clear: false,
				status: false,
				settingWindow: false,
				tableData: [],
				filter: {
					pageNum: 1,
					pageSize: 999,
					total: 0,
					month: new Date().getFullYear() + "-" + (new Date().getMonth() + 1),
					name: "",
				},
				selectStore: {},
			}
		},
		mounted() {
			this.getTurnover();
		},
		filters: {
			stateFormat(state) {
				switch (state) {
					case 1:
						return '正常营业';
					case 2:
						return '门店撤店';
					case 3:
						return '即将开业';
					case 4:
						return '门店调休';
					case 5:
						return '暂停营业';
					case 6:
						return '装修升级中';
				}
			},
			typeFormat(type) {
				switch (type) {
					case "1":
						return '店长';
					case "2":
						return '试用期';
					default:
						return '店员';
				}
			},
		},
		methods: {
			settings(obj) {
				this.settingWindow = true;
				this.selectStore = JSON.parse(JSON.stringify(obj));
				let str = this.filter.month.split("-");
				this.status = false;
				if (str[0] < new Date().getFullYear()) {
					this.status = true;
				} else {
					if (str[1] < new Date().getMonth() + 1) this.status = true;
				}
			},
			dataByPage(val) {
				this.filter.pageNum = val;
				this.getTurnover();
			},
			edit() {
				let data = {
					storeId: this.selectStore.id,
					turnover: this.selectStore.turnover,
					date: this.filter.month,
					workerTurnovers: [],
				};
				this.selectStore.workerTurnovers.forEach(res => {
					let temp = {
						storeId: res.storeId,
						workerId: res.id,
						turnover: res.turnover,
						date: this.filter.month,
					};
					data.workerTurnovers.push(temp);
				});
				this.$http.post("store/editTurnover", JSON.stringify(data)).then(res => {
					if (res.body.code == 200) {
						this.getTurnover();
						this.settingWindow = false;
						this.$message.success("保存成功");
					} else {
						this.$message.error(res.body.msg);
					}
				});
			},
			getTurnover() {
				this.$http.post("store/getTurnover", JSON.stringify(this.filter)).then(res => {
					this.tableData = res.body.data;
					this.tableData.forEach(ele => {
						ele.workerTurnovers.forEach(e => {
							if (e.turnover) e.turnover /= 100;
						});
						if (ele.turnover) ele.turnover /= 100;
					});
					this.filter.total = res.body.total;
				});
			},
			plsc: function() {
				var sj = document.querySelector('#sj')
				sj.click()
			},
			xuanzhe: function(val) {
				var sj = document.querySelector('#sj')
				let Formdata = new FormData;
				Formdata.append('file', val.target.files[0])
				let config = {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
				var that = this
				this.$http.post("store/turnoverImport", Formdata, config).then(function(res) {
					if (res.body.code == 200) {
						this.$message.success("导入成功")
						location.reload()
						this.getTurnover();
					} else {
						this.$message.error(res.body.msg)
					}
					// var t0 = setTimeout(function() {
					// 	this.$message.info("页面即将刷新")
					// },1000);
					var t = setTimeout(function() {
						console.log("刷新页面")
						// location.reload()
						// this.$router.go(-1)
						// this.$parent.reload()
						// this.reload();
						that.reload()
					}, 4000);
				})
			},
		}
	};
</script>
<style lang="less" scoped>
	.input_style {
		width: 100px;
		margin: 5px 10px;
	}
</style>